import type Konva from 'konva';
import { useCallback, useMemo } from 'react';
import useImage from 'use-image';
import { ROTATER_ICON } from './anchors';

export const useAnchorStyle = () => {
  const [icon] = useImage(ROTATER_ICON);

  const rotaterIconCanvas = useMemo(() => {
    if (!icon) return null;
    const canvas = document.createElement('canvas');
    canvas.width = 20;
    canvas.height = 20;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(icon, 0, 0, canvas.width, canvas.height);
    return canvas;
  }, [icon]);

  return useCallback(
    (anchor: Konva.Rect) => {
      if (anchor.hasName('middle-left') || anchor.hasName('middle-right')) {
        anchor.cornerRadius(10);
        anchor.height(20);
        anchor.offsetY(10);
        anchor.width(6);
        anchor.offsetX(3);
        return;
      }
      if (anchor.hasName('bottom-center') || anchor.hasName('top-center')) {
        anchor.cornerRadius(10);
        anchor.height(6);
        anchor.offsetY(3);
        anchor.width(20);
        anchor.offsetX(10);
        return;
      }
      if (anchor.hasName('rotater')) {
        anchor.setAttr('fill', null);
        anchor.cornerRadius(10);
        anchor.height(20);
        anchor.width(20);
        anchor.offsetY(10);
        anchor.offsetX(10);
        if (rotaterIconCanvas) {
          anchor.fillPatternImage(rotaterIconCanvas);
        }
        return;
      }
      anchor.cornerRadius(6);
      anchor.height(12);
      anchor.width(12);
      anchor.offsetY(6);
      anchor.offsetX(6);
    },
    [rotaterIconCanvas],
  );
};
